var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.activeVenue)?_c('div',[(_vm.activeTab == 0)?_c('div',{staticClass:"tab-general md:ml-4 md:mt-0 mt-4 ml-0"},[_c('eod-reports-list')],1):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }